import mutations from './occupationHealthReportConfig.mutations'
import actions from './occupationHealthReportConfig.actions'
import getters from './occupationHealthReportConfig.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
